import { Card, Typography, theme, Checkbox, Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import React from 'react'
import useMobileView from '@shared/hooks/isMobile'

const { Text } = Typography

export const Finance = () => {
    const {
        token: { colorPrimary }
    } = theme.useToken()
    const isMobile = useMobileView()
    return (
        <>
            <Card
                style={{ backgroundColor: '#ffff', width: isMobile ? 'auto' : 414, marginBottom: 10 }}
                bodyStyle={{ padding: '17px 22px' }}
            >
                <Checkbox>Выбрать все</Checkbox>
                <Checkbox style={{ marginTop: 17 }}>
                    На карту банка РФ{'   '}
                    <Tooltip title="Оплата будет отправлена на привязанную банковскую карту сразу после завершения сделки. Временно доступно только для карт РФ и РБ банков. Для успешной выплаты ваш профиль должен быть активирован через банк.">
                        <QuestionCircleOutlined style={{ color: colorPrimary, cursor: 'help' }} />
                    </Tooltip>
                    {'   '}
                    Как это работает?
                </Checkbox>
                <Checkbox style={{ marginTop: 17 }}>
                    На р/с ИП или Юр. лица{'   '}
                    <Tooltip title="Оплата будет отправлена на счет в банке. Данный способ оплаты доступен только для ставок от 315 000 руб. Важным условием является возможность принять денежные средства на счет ИП или юр. лица. Если вы не сможете предоставить соответствующие данные в процессе сделки, выберите другой способ оплаты.">
                        <QuestionCircleOutlined style={{ color: colorPrimary, cursor: 'help' }} />
                    </Tooltip>
                    {'   '}
                    Как это работает?
                </Checkbox>
                <Checkbox style={{ marginTop: 17 }}>
                    На электронный кошелек{'   '}
                    <Tooltip title="Оплата поступит на ваш баланс внутри биржи. Выплата возможна по заявке на привязанный криптокошелек.">
                        <QuestionCircleOutlined style={{ color: colorPrimary, cursor: 'help' }} />
                    </Tooltip>
                    {'   '}
                    Как это работает?
                </Checkbox>
            </Card>
            <Text>Подробнее об оплате и комиссии платежных систем.</Text>
        </>
    )
}
